module.exports = "<div class=\"no-data\" >\r\n  <img src=\"assets/img/no-data.gif\" alt=\"\">\r\n  <p>Data not <span>available !</span></p>\r\n</div>"